export default (score, tries = 1) => {
  let scoreClass;

  if (tries === 0) return '';

  if (score >= 75) {
    scoreClass = 'good';
  } else if ((score >= 50) && (score < 75)) {
    scoreClass = 'ok';
  } else if ((score >= 25) && (score < 50)) {
    scoreClass = 'do-better';
  } else {
    scoreClass = 'fail';
  }

  return scoreClass;
};



// WEBPACK FOOTER //
// ./src/modules/scoreclass.js